export interface ShadowRootMountResult {
  root: ShadowRoot | HTMLElement;
  host: HTMLElement;
  mode: 'shadow' | 'light';
}

export function createWidgetMountRoot(
  container: HTMLElement,
  useShadowDom = true
): ShadowRootMountResult {
  if (useShadowDom && container.attachShadow) {
    const existingShadowRoot = container.shadowRoot ?? container.attachShadow({ mode: 'open' });

    return {
      root: existingShadowRoot,
      host: container,
      mode: 'shadow'
    };
  }

  return {
    root: container,
    host: container,
    mode: 'light'
  };
}